import config from 'config';

import React from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// MUI
import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';
// Components
import Title from 'components/Title';
// Framer
import { motion } from 'framer-motion';
import { bottomAnimate, topAnimate } from 'utilities/Framer';

const ServiceArea:React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const { phoneNumber } = config;

  return (
    <motion.section
      data-container="area"
      className={classes.block}
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: 0.2 }}
    >
      <div className={[classes.blockContent, 'container'].join(' ')}>
        <motion.div variants={bottomAnimate} custom={1}>
          <Title>{t('homePage.area.label')}</Title>
        </motion.div>
        <motion.h2 className={classes.title} variants={topAnimate} custom={1}>
          {t('homePage.area.title')}
        </motion.h2>
        <div className={classes.columns}>
          <div className={classes.column}>
            <p className={classes.text}>{t('homePage.area.text')}</p>
            <p className={classes.hours}>{t('homePage.area.hours')}</p>
            <Button
              variant="contained"
              href={`tel:${phoneNumber.replace(/\s+/g, '')}`}
              sx={{ alignSelf: 'flex-start' }}
            >
              {t('homePage.area.button', { phone: phoneNumber })}
            </Button>
          </div>
          <div className={classes.column}>
            <h3 className={classes.subtitle}>{t('homePage.area.costTitle')}</h3>
            <p className={classes.text}>{t('homePage.area.costText')}</p>
            <h3 className={classes.subtitle}>{t('homePage.area.howTitle')}</h3>
            <ol className={classes.steps}>
              {[1, 2, 3].map(n => (
                <li key={n}>{t(`homePage.area.step${n}`, { phone: phoneNumber })}</li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </motion.section>
  );
}

export default ServiceArea;

const useStyles = makeStyles({
  block: {
    backgroundColor: '#e3e7ee',
    position: 'relative',
    padding: '16px',
    '@media (min-width: 600px)': {
      padding: '32px'
    },
    '@media (min-width: 1240px)': {
      padding: '40px 32px'
    },
  },
  blockContent: {
    paddingTop: '20px',
    '@media (min-width: 600px)': {
      paddingTop: '32px',
    },
    '@media (min-width: 1240px)': {
      paddingTop: '56px',
    },
  },
  title: {
    color: '#0e073c',
    letterSpacing: '1px',
    fontSize: '30px',
    textAlign: 'center',
    margin: '20px 0 40px',
    '@media (min-width: 600px)': {
      fontSize: '36px',
    },
    '@media (min-width: 1240px)': {
      fontSize: '48px',
    },
  },
  columns: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    '@media (min-width: 1240px)': {
      flexDirection: 'row',
      gap: '40px',
    },
  },
  column: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '25px',
    backgroundColor: '#fff',
    boxShadow: 'rgb(0, 0, 0, 0.1) 0 9px 15px',
    borderBottom: '#d3e7ff solid 9px',
    '@media (min-width: 1240px)': {
      padding: '35px',
    },
  },
  subtitle: {
    color: '#0e073c',
    fontSize: '22px',
    fontWeight: 600,
  },
  text: {
    color: '#696393',
    fontSize: '16px',
    lineHeight: 1.6,
  },
  hours: {
    color: '#0e073c',
    fontSize: '16px',
    fontWeight: 600,
  },
  steps: {
    color: '#696393',
    fontSize: '16px',
    lineHeight: 1.8,
    paddingLeft: '20px',
  },
});
